import { Outlet } from 'react-router-dom';

const Manage = () => <Outlet />;

export default Manage;
